// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1sfEw","modalFooterButton":"ModalNotes_modalFooterButton__125A4"};